/**
 * Выбор варианта рекламного плейсмента по (isFull, isDesktop).
 *
 * Одна реализация вместо ~18 копий тернарника, разъехавшихся по компонентам
 * и шаблонам.
 */

/** Полный вариант: full/prev × pc/mob. */
export function pickVariant(isFull, isDesktop) {
    return isFull ? (isDesktop ? "fullPc" : "fullMob") : isDesktop ? "prevPc" : "prevMob";
}

/** Вариант только по устройству — для слотов backClick/popup/refresh. */
export function pickDeviceVariant(isDesktop) {
    return isDesktop ? "pc" : "mob";
}

/**
 * Значение варианта из per-variant словаря.
 *
 * Скалярная форма (`backClick: 30345`) возвращается как есть: так исторически
 * записаны старые кампании, и консьюмеры на это опираются.
 */
export function selectVariant(options, isFull, isDesktop) {
    if (options === null || options === undefined) {
        return null;
    }

    if (typeof options !== "object") {
        return options;
    }

    const value = options[pickVariant(isFull, isDesktop)];

    return value === undefined ? null : value;
}

/** То же для per-device словаря со скалярным фолбэком. */
export function selectDeviceVariant(options, isDesktop) {
    if (options === null || options === undefined) {
        return null;
    }

    if (typeof options !== "object") {
        return options;
    }

    const value = options[pickDeviceVariant(isDesktop)];

    return value === undefined ? null : value;
}
